<template>
  <div>
    <mtd-row class="page-title-block">
      <mtd-col :span="24">
        <span class="page-head-title">报表推送</span>
      </mtd-col>
    </mtd-row>
    <mtd-row class="page-content-block">
      <mtd-col :span="24">
        <mtd-table :data="reminders_list">
          <mtd-table-column prop="createTime" label="时间" width="140">
            <template slot-scope="scope">
              {{scope.row.createTime|dateTimeFormat}}
            </template>
          </mtd-table-column>
          <mtd-table-column prop="beAlertedMis" label="告警接受人" show-overflow-tooltip width="140"/>
          <mtd-table-column prop="content" label="风险详情" show-overflow-tooltip >
            <template slot-scope="scope">
              {{ login_user.mis_id === scope.row.supervisor ? scope.row.superiorContent : scope.row.content }}
            </template>
          </mtd-table-column>
          <mtd-table-column prop="description" label="说明" width="120">
            <mtd-tag theme="gray" type="pure" class="page-head-title-tag">请查看</mtd-tag>
          </mtd-table-column>
          <mtd-table-column label="操作" width="80">
            <template slot-scope="scope">
              <mtd-button type="text" size="small" @click="show_detail(scope.row.id, scope.row.pageId)" style="color: #0a70f5">详情</mtd-button>
            </template>
          </mtd-table-column>
        </mtd-table>
        <div style="text-align: right;margin-top: 12px;">
          <mtd-pagination size="small" :total="pagination.total" :current-page="pagination.current_page"
                          :page-size="pagination.page_size" show-total style="display: inline-block;"
                          @change="handlePaginationChange"/>
        </div>
      </mtd-col>
    </mtd-row>
  </div>
</template>

<script>

  import moment from 'moment';
  import {mapActions} from 'vuex'

  export default {
    name: "index",
    filters: {
      dateTimeFormat(dateTime) {
        if (dateTime) {
          return moment(dateTime)
            .utcOffset(480)
            .format('YYYY-MM-DD HH:mm:ss');
        } else {
          return "";
        }
      },
    },
    data() {
      return {
        reminders_list: [],
        pagination: {
          total: 125,
          current_page: 1,
          page_size: 10,
        },
      }
    },
    mounted: function () {
      this.init_table();
    },
    computed: {
      login_user() {
        return this.$store.getters.get_login_user;
      },
    },
    methods: {
      ...mapActions([
        'api_list_statement',
      ]),
      async init_table() {
        let params = {pageNum: this.pagination.current_page, limit: this.pagination.page_size};
        let response = await this.api_list_statement(params);
        let result = response.data;
        this.reminders_list = result.items;
        this.pagination.total = result.tn;
      },
      show_detail(id, pageId) {
        this.$router.push('/statement/' + id + '/' + pageId);
      },
      handlePaginationChange(current){
        this.pagination.current_page = current;
        this.init_table();
      }
    }
  }
</script>

<style>
  .mtd-table-cell {
    font-size: 12px;
  }

  .page-head-title {
    font-family: PingFangSC-Medium, sans-serif;
    font-size: 20px;
    color: #333333;
    letter-spacing: 0.5px;
    line-height: 28px;
  }
</style>
